const flattenSegments = (segments = []) => segments.map((customerSegment) => customerSegment.customerSegmentName);

export default function isUserAllowed(restrictedToSegments, user) {
    const customerSegments = [
        ...flattenSegments(user?.customerSegments?.customerLevelOfService),
        ...flattenSegments(user?.customerSegments?.customerCategory),
        ...flattenSegments(user?.customerSegments?.marketingSegments),
        ...flattenSegments(user?.customerSegments?.dynamicSegments),
    ];
    const match = restrictedToSegments?.find((segment) => customerSegments.includes(segment));
    return match ? true : false;
}
